/**
 * Manda gli errori del logger alla function reportClientError, così si leggono
 * in Cloud Logging anche quando succedono sul telefono di un tester. Firebase si
 * carica solo al primo errore. Cosa passa, e cosa no, lo decide il logger.
 */
import { Capacitor } from "@capacitor/core";
import logger from "./logger";

logger.setRemoteSink(async (voce) => {
  const [{ functions }, { httpsCallable }] = await Promise.all([
    import("./firebase"),
    import("firebase/functions"),
  ]);
  let platform = "web";
  try {
    platform = Capacitor.getPlatform();
  } catch (e) {
    // fuori da Capacitor resta "web"
  }
  await httpsCallable(functions, "reportClientError")({ ...voce, platform });
});
